import { StyleSheet, TouchableOpacity, View } from "react-native";
import { XIcon } from "@phosphor-icons/react";

import { colors, spacing } from "../../../../styles/design-system";
import CustomButton from "../../../common/general/CustomButton/CustomButton";
import CustomModal from "../../../common/general/CustomModal/CustomModal";
import CustomSpacing from "../../../common/layout/CustomSpacing/CustomSpacing";
import CustomText from "../../../common/general/CustomText/CustomText";

type DeleteQuestionConfirmationModalProps = {
  visible: boolean;
  deleteCount: number;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
};

const DeleteQuestionConfirmationModal = ({
  visible,
  deleteCount,
  onClose,
  onConfirm,
  isDeleting,
}: DeleteQuestionConfirmationModalProps) => {
  return (
    <CustomModal
      visible={visible}
      onRequestClose={onClose}
      ariaLabel="Delete question confirmation"
      containerStyle={styles.modalContainer}
      bodyStyle={styles.modalBody}>
      <View>
        <View style={styles.header}>
          <CustomText
            text="Confirm Delete"
            size="m"
            weight="ultraBold"
            useTranslationText={true}
            style={styles.title}
          />
          <TouchableOpacity
            onPress={onClose}
            accessibilityRole="button"
            aria-label="Close modal"
            style={styles.closeButton}>
            <XIcon size={16} color={colors.grey[500]} weight="regular" />
          </TouchableOpacity>
        </View>

        <CustomText
          text={
            deleteCount > 1
              ? "Do you really want to delete {{count}} questions?"
              : "Do you really want to delete this question?"
          }
          size="s"
          weight="normal"
          useTranslationText={true}
          interpolation={{ count: deleteCount }}
          style={styles.message}
        />

        <CustomSpacing size="m" />

        <View style={styles.actions}>
          <CustomButton
            text="Cancel"
            useTranslationText={false}
            styleType="primaryTransparentStroke"
            size="s"
            onPress={onClose}
          />
          <CustomButton
            text="Delete"
            useTranslationText={false}
            styleType="primary"
            size="s"
            onPress={onConfirm}
            disabled={isDeleting}
          />
        </View>
      </View>
    </CustomModal>
  );
};

const styles = StyleSheet.create({
  modalContainer: {
    maxWidth: 380,
  },
  modalBody: {
    flexGrow: 0,
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: spacing.sm,
  },
  title: {
    color: colors.grey[800],
    lineHeight: 24,
  },
  closeButton: {
    padding: spacing.xs,
  },
  message: {
    color: colors.grey[700],
    lineHeight: 20,
  },
  actions: {
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: spacing.xs,
  },
});

export default DeleteQuestionConfirmationModal;
